// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3Vfry","header":"ClearentDisclaimer_header__23qyN","inner":"ClearentDisclaimer_inner__2jmoR"};